/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState, useEffect, useRef } from 'react';
import { FormButtons, SignupBgOne } from '../components';
import { useWindowDimensions } from '../utils/helpers';
import { images, mobileImages } from '../constants';

import flIcon from "../assets/images/icons/fl-icon.png";
import preloader from "../assets/images/preloaders/03-preloader-6px-7D0D39.gif";
import { CloseModal, Form, AccountLabel } from './artist';

export function Lover({ displayAll, passDisplayAll }) {
    const formRef = useRef();
    const scrollRef = useRef();

    const [formHasValue, setFormHasValue] = useState(false);
    const [displayNone, setDisplayNone] = useState(true);
    const [layoutHeight, setLayoutHeight] = useState(0);
    const [formData, setFormData] = useState([]);
    const [opacity, setOpacity] = useState(1);
    const [footerStyle, setFooterStyle] = useState({
        position: 'absolute',
        top: 0
    });
    const { windowWidth, isMobile } = useWindowDimensions();

    const getFormHasValue = (formValue) => setFormHasValue(formValue);
    const getFormData = (formData) => setFormData(formData);
    const onSetOpacity = (op) => setOpacity(op);
    const onSetDisplayNone = (d) => {
        setDisplayNone(d);
        passDisplayAll(!d);
        formRef.current.reset();
    };
    const onKeyboardShow = () => {
        setFooterStyle({
            position: 'relative',
            top: '6rem'
        });
    };
    const onKeyboardHide = () => {
        setFooterStyle({
            position: 'absolute',
            top: layoutHeight - 70
        });
    };

    useEffect(() => {
        setLayoutHeight(window.innerHeight);
        setFooterStyle({
            top: window.innerHeight - 70
        });
    }, []);
    useEffect(() => {
        displayAll ? setDisplayNone(false) : setDisplayNone(true);
    }, [displayAll]);
    useEffect(() => {
        // console.log(formData);
        // eslint-disable-next-line
    }, [formData]);

    return (
        <div id="signupFl" className={`signup-above-menu ${displayNone ? 'd-none' : ''}`}>
            {windowWidth <= 1030 ?   
                <>          
                    <CloseModal passOpacity={onSetOpacity} passDisplayNone={onSetDisplayNone} />
                    <AccountLabel icon={flIcon} type="lover"/> 
                </>
            : null}
            <div id="slide2" className="move">
                <div ref={scrollRef} className="scroll-container">
                    <SignupBgOne 
                        desktop={images['fa-bg2.jpg']}
                        mobile={mobileImages['fa-bg2.jpg']}
                    />
                    {windowWidth > 1030 ? <CloseModal passOpacity={onSetOpacity} passDisplayNone={onSetDisplayNone} /> : null}
                    <div id="faAccount" className="row" style={{ opacity: opacity }}>
                        {windowWidth > 1030 ?
                            <div className="form-header col-7 col-sm-7 col-md-7 col-lg-7">
                                <AccountLabel icon={flIcon} type="lover"/>
                                <p className="header pink-text">let's get to know<br /> one another better.</p>
                            </div>
                            :
                            <div className="form-header row m-0">
                                <p className="header pink-text">let's get to know<br /> one another better.</p>
                            </div>
                        }
                        <Form
                            ref={formRef}
                            lover={true}
                            passScrollRef={scrollRef}
                            windowWidth={windowWidth}
                            passFormHasValue={getFormHasValue}
                            passFormData={getFormData}
                            triggerKeyboardShow={onKeyboardShow}
                            triggerKeyboardHide={onKeyboardHide}
                        />
                    </div>
                    <FormButtons
                        opacity={opacity}
                        disabled={!formHasValue}
                        reset={() => formRef.current.reset()}
                        submit={() => formRef.current.submit()}
                        formData={formData}
                        preloader={preloader}
                        style={{
                            position: isMobile ? footerStyle.position : null,
                            top: isMobile ? footerStyle.top : null
                        }}
                    />
                </div>
            </div>
        </div>
    )
}
